<template>
    <nav class="page-nav">
        <div class="nav-btn" :class="{ 'active':  NAVBTN_ACTIVED}" @click.stop="navToggle">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <transition name="page-nav">
            <nav class="page-nav-box" v-show="NAVBTN_ACTIVED">
                <ul class="page-nav-ul">
                    <li class="page-nav-li" 
                    :class="{'actived': NAV_ACTIVE_INDEX == index+1}"
                    v-for="(item, index) in navlist"
                    :key="`nav-li-${index}`"
                    @click="goTo(index)"
                    >
                        <div class="nav-li-bg">
                            <p>{{ item.text }}</p>
                        </div>
                        <div class="nav-li-box">
                            <div class="nav-li-slide"></div>
                            <div class="nav-li-title">
                                <p>{{ item.text }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </nav>
        </transition>
    </nav>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "Nav",
    props: {
        navlist: {      // 导航栏列表
            type: Array,
            required: true
        },
        fullpage:{      // 全屏滚动对象
            required: true
        },    
    },
    components: {

    },
    data: () => ({
    }),
    created() {
    },
    mounted() {
    },
    watch: {
    },
    computed: {
        ...mapState({
            // 导航栏当前开启状态
            NAVBTN_ACTIVED: state => state.Nav.NAVBTN_ACTIVED,
        }),
        NAV_ACTIVE_INDEX() {    // 导航栏当前页签标识
            if(this.fullpage) {
                return this.fullpage.activeIndex
            }
        },
    },
    methods: {
        navToggle() {
            // 切换导航栏开启、关闭状态
            this.$store.commit("Nav/SET_NAVBTN_ACTIVED", !this.NAVBTN_ACTIVED)
        },
        goTo(index) {
            // 页签导航
            this.fullpage.goTo(index+1)
        }
    },
};
</script>

<style lang="scss" scoped>
.page-nav {
    position: fixed;
    top: pxTorem(22px);
    left: pxTorem(15px);
    z-index: 1000;
    
    .nav-btn {
        width: pxTorem(32px);
        height: pxTorem(32px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        cursor: pointer;

        &.active {
            span {
                &:nth-of-type(1) {
                    transform: translate(pxTorem(-6px), pxTorem(12px)) rotate(45deg);
                }
                &:nth-of-type(2) {
                    opacity: 0;
                }
                &:nth-of-type(3) {
                    transform: translate(pxTorem(4px), pxTorem(12px)) rotate(-45deg);
                }
            }
        }

        span {
            flex-grow: 0;
            width: 100%;
            height: pxTorem(3px);
            background: #fff;
            display: block;
            position: absolute;
            top: 50%;
            transition: all ease-in-out .3s;

            &:nth-of-type(1) {
                transform-origin: right center;
                transform: translate(0, pxTorem(-8px));
            }
            &:nth-of-type(3) {
                transform-origin: left center;
                transform: translate(0, pxTorem(8px));
            }
        }
    }
    .page-nav-box {
        width: pxTorem(260px);
        box-sizing: border-box;
        padding-left: pxTorem(17px);
        border-left: 2px solid #fff;
        position: absolute;
        top: 130%;
        left: 5%;

        .page-nav-ul {
            width: 100%;
            background: #000;
            box-sizing: border-box;
            border: 1px solid #101010;
            display: flex;
            flex-direction: column;
            padding: pxTorem(40px) 0;

            .page-nav-li {
                display: block;
                width: 100%;
                height: pxTorem(40px);
                position: relative;

                &:not(:last-child) {
                    margin-bottom: pxTorem(50px);
                }

                &.actived {
                    .nav-li-slide {
                        flex: 1;
                    }
                    .nav-li-bg {
                    }
                } 

                &:hover {
                    .nav-li-slide {
                        flex: 1;
                    }
                }         

                .nav-li-bg {
                    display: block;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;

                    p {
                        color: #171818;
                        font-family: 'Noto Sans KR', sans-serif;
                        font-size: pxTorem(29px);
                        font-weight: bold;
                        line-height: pxTorem(40px);
                    }
                }
                
                .nav-li-box {
                    width: 90%;
                    height: 100%;
                    display: flex;
                    position: absolute;
                    justify-content: flex-start;
                    align-items: center;
                    cursor: pointer;

                    .nav-li-slide {
                        height: pxTorem(5px);
                        background: #fff000;
                        transition: all .3s;
                    }
                    .nav-li-title {
                        margin-left: pxTorem(10px);
                        p {
                            color: #fff;
                            font-size: pxTorem(18px);
                            font-family: 'Noto Sans KR', sans-serif;
                        }
                    }
                }
            }
        }
    }
}

.page-nav-enter-active, .page-nav-leave-active {
    transition: all .5s;
}
.page-nav-enter, .page-nav-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}
</style>
